// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import filters from './filters'
import * as utils from './utils'
import Confirm from '@/components/Confirm'
import Snackbar from '@/components/Snackbar'
import Pager from '@/components/Pager'
import EventBus from '@/components/EventBus'
import Tooltips from '@/components/Tooltips'
import DatePickerPlus from '@/components/DatePickerPlus'
import TimeRangePicker from '@/components/TimeRangePicker'
import DatePicker from '@lred/vue2-datepicker'
// import '../static/css/material.font.css'
import './app.css'
import calc from 'calculatorjs'
import zhHans from './locale/vuetifyZhHans'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.min.css'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

filters(Vue)
Vue.use(VXETable)

// 注册插件
Vue.use(Vuetify)
Vue.prototype.$vuetify.lang.locales.zhHans = zhHans
Vue.prototype.$vuetify.lang.current = 'zhHans'

Vue.use(VuetifyDialog)

Vue.prototype.$calc = calc
Vue.prototype.$sleep = function (s) {
  return new Promise(resolve => {
    setTimeout(resolve, s)
  })
}

Vue.prototype.$hasPermission = function (name) {
  const rbacPermissions = store.state.userInfo.rbacPermissions
  // if (!rbacPermissions) {
  //   return false
  // }
  // if (!store.state.isPord) {
  //   // 非生产环境不判断入口权限
  //   return true
  // }
  return rbacPermissions.indexOf(name) > -1
}

Vue.use(Confirm, {
  buttonTrueText: '确定',
  buttonFalseText: '取消',
  width: 300,
  property: '$confirm'
})

Vue.component('DatePicker', DatePicker)
Vue.use(Snackbar, {
  mode: 'vertical',
  y: 'top'
})

Vue.component(Pager.name, Pager)
Vue.component(EventBus.name, EventBus)
Vue.component(Tooltips.name, Tooltips)
Vue.component('DatePickerPlus', DatePickerPlus)
Vue.component('TimeRangePicker', TimeRangePicker)
Vue.use(Viewer)

/* eslint-disable no-new */
/* eslint-disable */
window.vueApp = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

window._initSuccess = true
document.title = '清關系統'



// WEBPACK FOOTER //
// ./src/main.js